import {useAppState} from '@app/modules/apps/context';
import type {TranslationKey} from 'globalTranslations';
import {useTranslation as useNextTranslation} from 'next-i18next';

export const useTranslation = () => {
	const {t} = useNextTranslation();
	const {appName} = useAppState();
	const formalNameSpace = appName === 'Zen' ? 'formal' : 'regular';

	const translate = (
		key: TranslationKey,
		options?: {sprintf?: (string | number)[]; count?: number},
	) => {
		const [namespace, keyName] = key.split('.');

		const ns =
			namespace === 'formal'
				? [formalNameSpace, 'common']
				: [namespace, 'common'];

		return t(keyName, {
			ns,
			...options,
		});
	};
	return translate;
};
export type TranslationParams = Parameters<ReturnType<typeof useTranslation>>;
